import cx from 'classnames'
import { MultiStepStepLayout } from 'components/MultiStepFlow/MultiStepStepLayout/MultiStepStepLayout'
import { useBrandProfile } from 'hooks/queries/brandProfiles/useBrandProfile'
import { BrandProfileStepProps } from './Types'
import VirtualMarketerOnboardingStyles from 'screens/VirtualMarketerOnboarding/VirtualMarketerOnboarding.module.scss'
import { TopBar } from 'screens/VirtualMarketerOnboarding/TopBar/TopBar'
import { BrandProfileForStrategies } from './BrandProfileForStrategies'

export const BrandProfileForStrategiesStep = ({ id, language, onLanguageChange, ...rest }: BrandProfileStepProps) => {
  const { data: brandProfile } = useBrandProfile(id, { cacheTime: 60 * 1000 * 5 })

  return (
    <MultiStepStepLayout scrollContainerClassName={cx(VirtualMarketerOnboardingStyles.scrollContainer)}>
      <TopBar highlightStep="yourBusiness" />
      {brandProfile && (
        <BrandProfileForStrategies
          key={brandProfile.id}
          brandProfile={brandProfile}
          language={language}
          onLanguageChange={onLanguageChange}
          {...rest}
        />
      )}
    </MultiStepStepLayout>
  )
}
